import { userStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { Withdraw } from '../../pages';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import React from 'react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const WithdrawContainer = ({
	closeModal,
	sharedState,
	transferSwitchState,
	pinContent,
	setPinContent,
	setShowSurvey,
}) => {
	const { businessStore, walletStore } = useStores();

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.WALLETWITHDRAWAL);

	const validationSchema = () => {
		return yup.object({
			transactionAmount: yup
				.number()
				.min(100, 'Amount Should be greater than 100.00'),
		});
	};

	const onSubmit = payload => {
		const bankAccount =
			userStore.user.accountType === 'Business'
				? businessStore.business['withdrawalBankAccount']
				: userStore.user['withdrawalBankAccount'];
		if (!bankAccount) {
			return MimaToastUtil.error({
				message: constant.MissingWithdrawalAccount,
			});
		}
		payload.currencyCode = 'NGN';
		payload.narration = '';
		payload.saveBeneficiary = false;
		payload.beneficiaryAccountNumber = bankAccount.accountNumber;
		payload.accountName = bankAccount.accountName;
		payload.beneficiaryBank = bankAccount.bankCode;
		payload.isWithdrawal = true;
		walletStore.setTransferPayload(payload);
		transferSwitchState.goToConfirmPin();
	};

	const goBack = () => {
		if (pinContent) {
			setPinContent(false);
		} else {
			closeModal();
		}
	};

	return (
		<Withdraw
			onSubmit={onSubmit}
			transferSwitchState={transferSwitchState}
			sharedState={sharedState}
			closeModal={closeModal}
			validationSchema={validationSchema}
			goBack={goBack}
			setShowSurvey={setShowSurvey}
			needFeedback={needFeedback}
		/>
	);
};

export default observer(WithdrawContainer);
